import { Descriptions } from 'antd'
/**
 *
 * @param {Object} detail 详情数据
 * @param {Array} fileds 字段列表
 * @param {Object} {name,label,span,contentStyle} 字段列表里每一项，span为所占item个数，contentStyle为内容样式
 * @param {Object} column 排列方式
 * @returns
 */
const DescribeList = ({
  detail = {},
  fileds = [],
  column = { xs: 1, sm: 2, md: 4 },
}) => {
  return (
    !!fileds.length && (
      <Descriptions column={column} style={{padding:'0 8px'}}>
        {fileds.map((item) => (
          <Descriptions.Item
            label={item.label}
            key={item.value}
            // span={item.span || 1}
            contentStyle={item.contentStyle}
          >
            {(item.render
              ? item.render(detail[item.value], detail)
              : detail[item.value]) || '-'}
          </Descriptions.Item>
        ))}
      </Descriptions>
    )
  )
}
export default DescribeList
